import Box, { BoxProps } from '@mui/material/Box'
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress'
import { styled } from '@mui/material/styles'
import { THEME } from '../../global'

interface IProps extends Omit<BoxProps, ''> {
  value: number
  barHeight?: number
  bgColor?: string
  brColor?: string
}

const BorderLinearProgress = styled(LinearProgress)(({ value }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: THEME.colors.tertiary,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor:
      value === 100 ? THEME.colors.success : THEME.colors.primary,
  },
}))

export function SourceLevelBar({ value = 0, barHeight, ...props }: IProps) {
  return (
    <Box {...props} sx={{ ...props.sx }}>
      <BorderLinearProgress
        sx={{ height: barHeight }}
        variant="determinate"
        value={value}
      />
    </Box>
  )
}
